import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HighchartsChartModule } from 'highcharts-angular';

import { NgxMaskModule, IConfig } from 'ngx-mask';
import { SharedDependenciesModule } from '../../../../shared';

import { DiagnosticsParameterItemComponent } from './diagnostics-parameters/diagnostics-parameter-item/diagnostics-parameter-item.component';
import { DiagnosticsParametersComponent } from './diagnostics-parameters/diagnostics-parameters.component';
import { DiagnosticsDefaultTemplateComponent } from './diagnostics-view/diagnostics-default-template/diagnostics-default-template.component';
import { IsDescriptionPipe } from './diagnostics-view/diagnostics-default-template/is-description.pipe';
import { VddDateEditComponent } from './diagnostics-view/vdd-date-edit/vdd-date-edit.component';
import { VddDateReadonlyComponent } from './diagnostics-view/vdd-date-readonly/vdd-date-readonly.component';
import { VddEnumEditComponent } from './diagnostics-view/vdd-enum-edit/vdd-enum-edit.component';
import { VddEnumImageEditComponent } from './diagnostics-view/vdd-enum-image-edit/vdd-enum-image-edit.component';
import { VddEnumReadonlyNoIntervalComponent } from './diagnostics-view/vdd-enum-readonly-no-interval/vdd-enum-readonly-no-interval.component';
import { VddEnumReadonlyComponent } from './diagnostics-view/vdd-enum-readonly/vdd-enum-readonly.component';
import { VddFalseTrueReadonlyComponent } from './diagnostics-view/vdd-false-true-readonly/vdd-false-true-readonly.component';
import { VddIpAddressEditComponent } from './diagnostics-view/vdd-ip-address-edit/vdd-ip-address-edit.component';
import { VddMacAddressEditComponent } from './diagnostics-view/vdd-mac-address-edit/vdd-mac-address-edit.component';
import { VddNumberEditComponent } from './diagnostics-view/vdd-number-edit/vdd-number-edit.component';
import { VddNumberReadonlyComponent } from './diagnostics-view/vdd-number-readonly/vdd-number-readonly.component';
import { VddTextEditComponent } from './diagnostics-view/vdd-text-edit/vdd-text-edit.component';
import { VddTextReadonlyComponent } from './diagnostics-view/vdd-text-readonly/vdd-text-readonly.component';
import { VddWriteErrorModalComponent } from './diagnostics-view/vdd-write-error-modal/vdd-write-error-modal.component';
import { DiagnosticsComponent } from './diagnostics.component';
import { ExtendedParametersTabComponent } from './extended-parameters-tabs/extended-parameters-tab/extended-parameters-tab.component';
import { ExtendedParametersTabsComponent } from './extended-parameters-tabs/extended-parameters-tabs.component';
import { VddIpAddressReadonlyComponent } from './diagnostics-view/vdd-ip-address-readonly/vdd-ip-address-readonly.component';
import { VddMacAddressReadonlyComponent } from './diagnostics-view/vdd-mac-address-readonly/vdd-mac-address-readonly.component';
import { VddStartStopComponent } from './diagnostics-view/vdd-start-stop/vdd-start-stop.component';
import { AddTimePhaseModalComponent } from './diagnostics-view/vdd-start-stop/add-time-phase-modal/add-time-phase-modal.component';
import { VddBooleanChoiceComponent } from './diagnostics-view/vdd-boolean-choice/vdd-boolean-choice.component';
import { DiagnosticsManagementTabComponent } from './diagnostics-management-tab/diagnostics-management-tab.component';
import { DiagnosticsDynamicMetadataComponentComponent } from './diagnostics-view/diagnostics-default-template/diagnostics-dynamic-metadata-component/diagnostics-dynamic-metadata-component.component';
import { DiagnosticsDynamicStructureComponentComponent } from './diagnostics-view/diagnostics-default-template/diagnostics-dynamic-structure-component/diagnostics-dynamic-structure-component.component';
import { VddVinComponent } from './diagnostics-view/vdd-vin/vdd-vin.component';
import { ExtendedParameterWelcomeScreenComponent } from './extended-parameter-welcome-screen/extended-parameter-welcome-screen.component';
import { DiagnosticsVddSelectionModalComponent } from './diagnostics-vdd-selection-modal/diagnostics-vdd-selection-modal.component';
import { DiagnosticsUseCasesModalComponent } from './diagnostics-use-cases-modal/diagnostics-use-cases-modal.component';
import { VddSensorComponent } from './diagnostics-view/vdd-sensor/vdd-sensor.component';

export const options: Partial<null | IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  imports: [SharedDependenciesModule, HighchartsChartModule, RouterModule, NgxMaskModule.forRoot()],
  exports: [
    DiagnosticsComponent,
    VddDateReadonlyComponent,
    VddEnumReadonlyComponent,
    VddNumberReadonlyComponent,
    VddTextReadonlyComponent,
    DiagnosticsDefaultTemplateComponent,
  ],
  declarations: [
    DiagnosticsComponent,
    DiagnosticsParameterItemComponent,
    DiagnosticsParametersComponent,
    DiagnosticsDefaultTemplateComponent,
    VddTextReadonlyComponent,
    VddFalseTrueReadonlyComponent,
    VddNumberReadonlyComponent,
    VddEnumReadonlyComponent,
    VddDateReadonlyComponent,
    VddEnumReadonlyNoIntervalComponent,
    VddDateEditComponent,
    VddEnumEditComponent,
    VddEnumImageEditComponent,
    VddNumberEditComponent,
    VddTextEditComponent,
    VddIpAddressEditComponent,
    VddMacAddressEditComponent,
    VddWriteErrorModalComponent,
    ExtendedParametersTabComponent,
    ExtendedParametersTabsComponent,
    IsDescriptionPipe,
    VddIpAddressReadonlyComponent,
    VddMacAddressReadonlyComponent,
    VddStartStopComponent,
    AddTimePhaseModalComponent,
    VddBooleanChoiceComponent,
    DiagnosticsManagementTabComponent,
    DiagnosticsDynamicMetadataComponentComponent,
    DiagnosticsDynamicStructureComponentComponent,
    VddVinComponent,
    ExtendedParameterWelcomeScreenComponent,
    DiagnosticsVddSelectionModalComponent,
    DiagnosticsUseCasesModalComponent,
    VddSensorComponent,
  ],
  providers: [],
})
export class DiagnosticsModule {}
